import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../services/data.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MessageService } from '../services/message.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-driver-form',
  templateUrl: './driver-form.component.html',
  styleUrls: ['./driver-form.component.scss'],
})
export class DriverFormComponent {
  apiUrl = environment.apiUrl;
  url: string = 'users';
  urlTwo: string = 'services';
  id!: string;
  form!: FormGroup;
  formTwo!: FormGroup;
  roles: Array<any> = [];
  imgFile: File | null = null;
  imgPreview: string | ArrayBuffer | null = null;
  carPhotos: File[] = [];
  insurancePhoto: File | null = null;
  step = 0;
  imgDriver: string;
  imgLicense: string;
  imgCard: string;
  imgReg: string;
  imgModal: string;
  showModal = false;
  showModalImg = false;
  update = false;
  isLoading = false;

  public data = {
    nameService: '',
    ref: '',
    createdAt: '',
    address: '',
    listDropAddress: [],
    pickUptime: '',
    dropOffTime: '',
    distance: '',
    price: '',
    stops: '',
    listStopAddress: [],
    startAddress: '',
    timeStop: '',
    distanceStop: '',
  };

  public services: Array<any> = [];
  public searchedService: any;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private datePipe: DatePipe
  ) {
    this.form = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      birthdate: ['', [Validators.required]],
      address: ['', [Validators.required]],
      apt: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zip: ['', [Validators.required]],
      country: ['', [Validators.required]],
      username: ['', [Validators.required]],
      role: ['', [Validators.required]],
      status: [''],
      suspended: [''],
      password: [''],
      indicative: [''],
      phone: [''],
      runner: [false],
      handler: [false],
      driverFields: this.fb.group({
        imgDriver: [''],
        /* vehicles: this.fb.group({
          type: [''],
          name: [''],
          make: [''],
          model: [''],
          year: [''],
          size: [''],
          color: [''],
          plate: [''],
          insuranceCompany: [''],
          policy: [''],
          imgRegistration: [''],
          imgCard: [''],
        }), */
        vehicles: this.fb.array([
          this.fb.group({
            type: [''],
            name: [''],
            make: [''],
            model: [''],
            year: [''],
            size: [''],
            color: [''],
            plate: [''],
            insuranceCompany: [''],
            policy: [''],
            imgRegistration: [''],
            imgCard: [''],
          }),
        ]),
        license: this.fb.group({
          licenseNumber: [''],
          state: [''],
          expiationDate: [''],
          imgLicense: [''],
          formattedDate: [''],
        }),
        bank: this.fb.group({
          name: [''],
          number: [''],
          account: [''],
          aba: [''],
          zelle: this.fb.group({
            emailOrPhone: [''],
            fullname: [''],
          }),
          venmo: this.fb.group({
            emailOrPhone: [''],
            fullname: [''],
          }),
          paypal: this.fb.group({
            emailOrPhone: [''],
            fullname: [''],
          }),
          applepay: this.fb.group({
            emailOrPhone: [''],
            fullname: [''],
          }),
        }),
        background: this.fb.group({
          number: [''],
        }),
      }),
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.selectDataRoles();

      this.id = params['id'];

      if (this.id) {
        this.getData();
        this.selectDataRoles();
        this.getDataDriver();
      }
    });
  }

  /*  pru() {
    console.log('form', this.form.value);
  }
 */
  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getDataDriver() {
    this.dataService.getData(`services/driver/${this.id}`).subscribe(
      //this.dataService.getData(`services/client/pending/${this.id}`).subscribe(
      //client/pending
      (response) => {
        let result = response;

        console.log('stttt', result);
        this.services = result.data;
        this.services.sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();

          // Ordenar de forma descendente
          return dateB - dateA;
        });

        this.services.forEach((service, index) => {
          service['originalIndex'] = index;
        });

        this.searchedService = this.services.slice();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getData(): void {
    this.dataService
      .getData(`${this.url}/driver/${this.id}`)
      .subscribe((response) => {
        console.log('reponse edit', response);
        //console.log('reponse edit2', response.rstAdd?.data?.license?.expiationDate);
        const rawExpirationDate = response.rstAdd?.data?.license?.expiationDate;
        const createdDate = new Date(rawExpirationDate);
        const formattedDate = this.datePipe.transform(
          createdDate,
          'dd/MM/yyyy'
        );

        console.log('formattedDate', formattedDate);
        this.form.patchValue({
          firstname: response.rst.firstname,
          lastname: response.rst.lastname,
          birthdate: response.rst.birthdate,
          address: response.rst.address,
          //apt: response.rst.apt ,
          apt: response.rst.apt != 'null' ? response.rst.apt : '',
          city: response.rst.city,
          state: response.rst.state,
          zip: response.rst.zip,
          country: response.rst.country,
          username: response.rst.username,
          role: response.rst.role,
          status: response.rst.status,
          suspended: response.rst.suspended,
          indicative: response.rst.indicative,
          phone: response.rst.phone,
          runner: response.rst?.runner,
          handler: response.rst?.handler,
          driverFields: {
            imgDriver: response.rstAdd?.data?.imgDriver,
            license: {
              licenseNumber: response.rstAdd?.data?.license?.licenseNumber,
              state: response.rstAdd?.data?.license?.state,
              expiationDate: response.rstAdd?.data?.license?.expiationDate,
              imgLicense: response.rstAdd?.data?.license?.imgLicense,
              formattedDate: formattedDate,
            },
            bank: {
              name: response.rstAdd?.data?.bank?.name,
              number: response.rstAdd?.data?.bank?.number,
              account: response.rstAdd?.data?.bank?.account,
              zelle: {
                emailOrPhone: response.rstAdd?.data?.bank?.zelle?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.zelle?.fullname,
              },
              venmo: {
                emailOrPhone: response.rstAdd?.data?.bank?.venmo?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.venmo?.fullname,
              },
              paypal: {
                emailOrPhone: response.rstAdd?.data?.bank?.paypal?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.paypal?.fullname,
              },
              applepay: {
                emailOrPhone:
                  response.rstAdd?.data?.bank?.applepay?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.applepay?.fullname,
              },
            },
            background: {
              number: response.rstAdd?.data?.background?.number,
            },
          },
        });

        /*const driverFieldsGroup = this.form.get('driverFields') as FormGroup;

         driverFieldsGroup.patchValue({
          imgDriver: response.rstAdd?.data?.imgDriver,
            license: {
              licenseNumber: response.rstAdd?.data?.license?.licenseNumber,
              state: response.rstAdd?.data?.license?.state,
              expiationDate: response.rstAdd?.data?.license?.expiationDate,
              imgLicense: response.rstAdd?.data?.license?.imgLicense,
              formattedDate: formattedDate,
            },
            bank: {
              name: response.rstAdd?.data?.bank?.name,
              number: response.rstAdd?.data?.bank?.number,
              account: response.rstAdd?.data?.bank?.account,
              zelle: {
                emailOrPhone: response.rstAdd?.data?.bank?.zelle?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.zelle?.fullname,
              },
              venmo: {
                emailOrPhone: response.rstAdd?.data?.bank?.venmo?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.venmo?.fullname,
              },
              paypal: {
                emailOrPhone: response.rstAdd?.data?.bank?.paypal?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.paypal?.fullname,
              },
              applepay: {
                emailOrPhone:
                  response.rstAdd?.data?.bank?.applepay?.emailOrPhone,
                fullname: response.rstAdd?.data?.bank?.applepay?.fullname,
              },
            },
            background: {
              number: response.rstAdd?.data?.background?.number,
            },
        }); */

        const vehiclesArray = this.form.get(
          'driverFields.vehicles'
        ) as FormArray;
        while (vehiclesArray.length) {
          vehiclesArray.removeAt(0);
        }

        response.rstAdd?.data?.vehicles?.forEach((vehicle: any) => {
          const vehicleGroup = this.fb.group({
            type: [vehicle.type],
            name: [vehicle.name],
            make: [vehicle.make],
            model: [vehicle.model],
            year: [vehicle.year],
            size: [vehicle.size],
            color: [vehicle.color],
            plate: [vehicle.plate],
            insuranceCompany: [vehicle.insuranceCompany],
            policy: [vehicle.policy],
            imgRegistration: [vehicle.imgRegistration],
            imgCard: [vehicle.imgCard],
          });
          vehiclesArray.push(vehicleGroup);
        });

        console.log('form value des', this.form.value);
        this.viewDriverImgUrl();
        this.licenseImgUrl();
        //this.changeStep(1);

        /* if (response.img) {
        this.imgPreview = response.img.startsWith('http') ? response.img : environment.apiUrl + response.img;
      } */

        /* if (response.carPhotos && Array.isArray(response.carPhotos)) {
        this.carPhotos = response.carPhotos.map(photo => {
          const file = new File([], photo.filename, { type: 'image/jpeg' });
          Object.defineProperty(file, 'url', { value: photo.url });
          return file;
        });
      }

      if (response.insurancePhoto) {
        const file = new File([], response.insurancePhoto.filename, { type: 'image/jpeg' });
        Object.defineProperty(file, 'url', { value: response.insurancePhoto.url });
        this.insurancePhoto = file;
      } */
      });
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/logistics');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        console.log('response en update', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.isLoading = false;
          this.router.navigateByUrl('/logistics');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectDataRoles(): void {
    this.dataService.getData('roles/select').subscribe((response) => {
      console.log('response.roles', response);
      this.roles = response.data;
    });
  }

  changeStep(step: number) {
    this.step = step;
    /* if (step == 1) {
      this.licenseImgUrl();
    }
    if (step == 5) {
    } */
  }

  get driverImgUrl(): string {
    const img = this.form.get('driverFields.imgDriver')?.value;

    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  }

  viewDriverImgUrl() {
    console.log('estoy en viewDriverImgUrl');
    const img = this.form.get('driverFields.imgDriver')?.value;
    console.log('validando form', this.form.get('driverFields')?.value);
    /* const driverFields = this.form.get('driverFields') as FormGroup;
    const img = driverFields?.get('imgDriver')?.value; */

    console.log('Valor de imgDriver:', img);
    console.log('Valor de apiUrl:', this.apiUrl);
    this.imgDriver = img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';

    //this.openModalImg('imgDriver');
  }

  /* get licenseImgUrl(): string {
    const img = this.form.get('driverFields.license.imgLicense')?.value;
    console.log('img license', img);
    this.img = img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  } */

  licenseImgUrl() {
    const img = this.form.get('driverFields.license.imgLicense')?.value;
    //console.log('Valor de licenseImgUrl:', img);
    //console.log('img license', img);
    this.imgLicense = img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';

    //this.openModalImg('imgLicense');
    /* return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg'; */
  }

  get vehicles() {
    return this.form.get('driverFields.vehicles') as FormArray;
  }

  //getCardVehicle(index: number): string {
  getCardVehicle(index: number) {
    //const vehicles = this.form.get('driverFields.vehicles') as FormArray;
    const img = this.vehicles.at(index)?.get('imgCard')?.value;

    console.log(`card vehículo [${index}]:`, img);
    this.imgCard = img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';

    this.openModalImg('imgCard');

    /* return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg'; */
  }

  //getRegVehicle(index: number): string {
  getRegVehicle(index: number) {
    //const vehicles = this.form.get('driverFields.vehicles') as FormArray;
    const img = this.vehicles.at(index)?.get('imgRegistration')?.value;

    console.log(`registration vehículo [${index}]:`, img);
    this.imgReg = img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';

    this.openModalImg('imgReg');

    /* return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg'; */
  }

  openEmail(email: string) {
    if (!email) return;

    const subject = encodeURIComponent('Contacto desde sistema');
    const body = encodeURIComponent(
      'Hola,\n\nMe comunico contigo desde el sistema.\n\nSaludos.'
    );
    //const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    const chooserUrl = `https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
      gmailComposeUrl
    )}`;

    window.open(chooserUrl, '_blank');
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-EN', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();
    const newDate = `${month} ${day}/${year}`;

    return newDate;
  }

  getNumber(index: number): number {
    let count = 0;
    for (let i = 0; i <= index; i++) {
      if (this.services[i]['data'][0].when['nameService'] === 'RUNNER') {
        count++;
      }
    }
    return count;
  }

  searchService(event: any) {
    const text = event.target.value;
    this.searchedService = this.services;

    if (text && text.trim() != '') {
      //text.trim texto no vacio, o solo espacios en blanco
      this.searchedService = this.searchedService.filter((service: any) => {
        return service['ref'].toLowerCase().indexOf(text.toLowerCase()) > -1;
      });
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  getDataService(id: string): void {
    this.dataService.getData(`${this.urlTwo}/${id}`).subscribe(
      (response) => {
        let result = response;
        this.data.listDropAddress = [];
        console.log('resultado de service', result);
        //console.log('resultado de service2', result['rst'].data[0].listDrop.length);

        this.data.nameService = result['rst'].data[0].when['nameService'];
        this.data.ref = result['rst']['ref'];
        this.data.createdAt = result['rst']['createdAt'];
        this.data.address = result['rst'].data[0].fullAddress;
        this.data.pickUptime = result['rst'].data[0]['open'];

        this.data.dropOffTime = result['rst'].data[0].drop['close'];
        this.data.distance = result['rst'].data[0].drop['distance']['distance'];

        this.data.price = result['rst']['total'];

        //if (this.data.nameService != 'RUNNER') {
        for (let i = 0; i < result['rst'].data[0].listDrop.length; i++) {
          this.data.listDropAddress.push(
            result['rst'].data[0].listDrop[i].fullAddress
          );
        }
        //}

        this.openModal();
        console.log('resultado de servicio', this.data);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openModalImg(img: string) {
    console.log('img', img);
    this.showModalImg = true;

    if (img == 'imgDriver') {
      this.imgModal = this.imgDriver;
      console.log('imgDriver', this.imgDriver);
    } else if (img == 'imgLicense') {
      this.imgModal = this.imgLicense;
      console.log('imgLicense', this.imgLicense);
    } else if (img == 'imgCard') {
      this.imgModal = this.imgCard;
      console.log('imgCard', this.imgCard);
    } else if (img == 'imgReg') {
      this.imgModal = this.imgReg;
      console.log('imgReg', this.imgReg);
    }
  }

  closeModalImg() {
    this.showModalImg = false;
    this.imgModal = '';
  }

  enableUpdate() {
    this.update = !this.update;
  }

  back() {
    this.router.navigateByUrl('/logistics');
  }
}
